export default {
  id: 'vitalSign/OXYGEN_SATURATION/v1',
  formSchema: {
    title: 'encounter:widget.vitalSigns.oxygenSaturation',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'integer',
        minimum: 1,
        maximum: 999,
        title: 'encounter:widget.vitalSigns.oxygenSaturation'
      }
    },
    iconClass: 'icon-apps',
    measurement: 'SpO2'
  },
  uiSchema: {
    id001: { 'ui:widget': 'customI18nNumericWidget' },
    'x-customClass': 'vital-signs-widget',
    'x-cancelBtnSize': 'sm',
    'x-saveBtnSize': 'sm'
  }
};
